<script>
  /**
   * @type {string}
   */
  export let color = "#0000";
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
>
  <path
    d="M11.9954 3.80005C13.1331 3.80005 14.1975 4.01518 15.1917 4.4436C16.1953 4.87614 17.0632 5.46141 17.8 6.19751C18.5371 6.93367 19.122 7.80086 19.5549 8.80298C19.9838 9.79545 20.2004 10.8578 20.2004 11.9954C20.2004 13.1331 19.9843 14.1975 19.5559 15.1917C19.1234 16.1952 18.539 17.0632 17.803 17.8C17.0668 18.5371 16.1996 19.122 15.1975 19.5549C14.2049 19.9839 13.142 20.2004 12.0042 20.2004C10.8665 20.2004 9.80296 19.9843 8.80884 19.5559C7.80524 19.1234 6.9373 18.539 6.20044 17.803C5.46331 17.0668 4.87754 16.1997 4.44458 15.1975C4.01567 14.2049 3.80005 13.142 3.80005 12.0042C3.80007 10.8665 4.01522 9.80295 4.4436 8.80884C4.87615 7.80509 5.46136 6.93738 6.19751 6.20044C6.9337 5.46331 7.8008 4.87754 8.80298 4.44458C9.79539 4.01582 10.8578 3.8001 11.9954 3.80005Z"
    fill={color}
    stroke="currentColor"
  />
</svg>
